import generateBasicEntityActions from './generateBasicEntityActions';

const basicEntityActions = generateBasicEntityActions('tasks', 'task');
const taskActions = {
  createAll: (params) => {
    const { client_ids } = params;
    delete params.client_ids;
    const newParams = { client_ids, task: params };

    return {
      API_CALL: {
        httpMethod: 'POST',
        endpoint: 'tasks/create_all',
        params: newParams,
      },
    };
  },

  deleteWithoutCallback: id => ({
    API_CALL: {
      httpMethod: 'DELETE',
      endpoint: `tasks/${id}`,
    },
  }),

  destroyAll: params => ({
    API_CALL: {
      httpMethod: 'PUT',
      endpoint: 'tasks/destroy_all',
      params,
    },
  }),

  ...basicEntityActions,
};

export default taskActions;
